<template>
  <div class="new-context-toolbar-wrap">
    <or-switch
      v-if="entityExtractionEnabled"
      :label="$t('common.context.context_new_toolbar.patternsView')"
      :value="localPatternView"
      @input="onChange"
      @change="fetchCategories()"
    />
    <div v-else />

    <or-button
      class="add-context-btn"
      type="secondary"
      size="small"
      icon="add"
      disableRipple
      @click="addContext"
    >
      {{ $t('common.context.context_new_toolbar.addContext') }}
    </or-button>
  </div>
</template>

<script>
import _ from 'lodash'
import KnowledgeBus from '@/KnowledgeBus'
import { mapActions, mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters('knowledgebase', ['getCurrent']),
    entityExtractionEnabled () {
      return _.includes(this.getCurrent.extensions, 'luis')
    },
    localPatternView: {
      get () {
        return this.isPatternView
      },
      set (value) {
        this.$emit('update:isPatternView', value)
      }
    }
  },

  props: {
    isPatternView: Boolean
  },

  methods: {
    ...mapActions('knowledgebase', ['fetchCategories']),

    onChange (value) {
      this.localPatternView = value
      this.$nextTick(() => {
        // I dare you to uncomment it (will simply DDoS backend)
        // Times DDoS'ed: 1
        // this.fetchCategories()
      })
    },

    addContext () {
      KnowledgeBus.$emit('context-form::show')
    }
  }
}
</script>

<style lang="scss" scoped>
.new-context-toolbar-wrap {
  display: flex;
  height: 32px;
  justify-content: space-between;
  align-items: center;
  margin-top: 8px;

  .add-context-btn {
    border: none;
    padding: 0;
    outline: none;
  }
}
</style>
